import * as actions from "./../actions/actionTypes";
const initState = [];
const productReducer = (state = initState, action) => {
  switch (action.type) {
    case actions.FETCH_PRODUCTS:
      return action.payload;
    default:
      return state;
  }
};

export default productReducer;
